// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { PFixField } from './PFixField';
export class PFixByteArrayField extends PFixField {
    constructor(fieldId, buffer) {
        super(fieldId, buffer);
        this.Value = [];
    }
    ReadValue(buffer) {
        const len = buffer.ReadInt32();
        this.Value = buffer.ReadBuffer(len).ReadAllBytes();
    }
    Write(buffer) {
        buffer.WriteShort(this.FieldId);
        const len = this.Value.length;
        buffer.WriteInt32(len);
        buffer.WriteAllBytes(this.Value);
    }
}
